import { apiClient } from '@/shared/api';
import type { TeamScheduleQuery, TeamScheduleResponse } from '@aegislab/shared';

export type { TeamScheduleResponse };

/**
 * 내 팀 일정 — 내가 속한 모든 팀의 휴가(이름·날짜·종일/반차) · 퀘스트 마감 · 캠페인 일정.
 * 팀 id 를 받지 않는다 — 서버가 로그인 사용자의 소속으로만 고르므로 남의 팀이 섞일 수 없다.
 */
export const fetchMyTeamSchedule = async (
  query: TeamScheduleQuery
): Promise<TeamScheduleResponse> => {
  const response = await apiClient.get<TeamScheduleResponse>('/attendance/team-schedule', {
    params: query,
  });
  return response.data;
};
